import React, { useContext } from 'react';
import { Route, Routes, Navigate, Outlet } from 'react-router-dom';
import { Layout } from 'antd';

import SideBarLayout from './SideBarLayout';
import HeaderLayout from './HeaderLayout';
import FooterLayout from './FooterLayout';

import { authRoutes } from '../router';
import { LayoutContext } from '../contexts';

const { Content } = Layout;

function MainLayout() {
  const { sideBarCollapsed, isMobile } = useContext(LayoutContext);

  const getMainLayoutStyle = () => {
    if (isMobile) {
      return { marginLeft: 0 };
    }
    return { marginLeft: sideBarCollapsed ? 80 : 200 };
  };

  return (
    <Layout hasSider={true} className="main-layout">
      <SideBarLayout isMobile={isMobile} />
      <Layout style={getMainLayoutStyle()} className="main-content-layout">
        <HeaderLayout isMobile={isMobile} />
        <Content
          style={{
            minHeight: 'calc(100vh - 160px)',
            height: '100%'
          }}
          className="main-content"
        >
          <Routes>
            {authRoutes.map(route => (
              <Route
                exact={true}
                key={route.path}
                path={route.path}
                element={<route.component />}
              />
            ))}
            <Route path="*" />
          </Routes>
        </Content>
        <FooterLayout />
      </Layout>
    </Layout>
  );
}

export default MainLayout;
